<template>
  <div class="order-card">
    <div class="side-left">
      <h4 class="title" :title="data.title">{{ data.title }}</h4>
      <div class="values">
        <!-- 债权 -->
        <p
          class="value amount"
          v-if="
            Number(data.original_type) === 0 || Number(data.original_type) === 1
          "
        >
          {{ data.creditAmountTrans }}
        </p>
        <p class="value address" v-else>
          {{ data.abstract }}
        </p>
      </div>
      <p class="description" v-if="data.pm_name">
        所在地区：{{ data.pm_address }}
      </p>
      <p class="description">创建时间：{{ data.createdate }}</p>
    </div>
    <div class="side-right">
      <router-link
        :to="{
          name: 'assetdetail',
          query: { original_type: data.original_type },
          params: { id: data.id }
        }"
        class="more-icon"
      >
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <div v-if="!getToken" class="disabled-mask" @click="tips"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      default: () => ({
        title: ""
      })
    }
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    tips() {
      this.$message.warning("请登录");
    }
  }
};
</script>

<style lang="scss">
.order-card {
  display: flex;
  height: 154px;

  .side-left {
    padding: 20px;
    width: calc(100% - 30px);
  }

  .side-right {
    position: relative;
    width: 30px;
    cursor: pointer;

    .more-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      text-decoration: none;
      color: $high;
      font-size: 28px;
      background: rgba(68, 151, 150, 0.1);
      transition: background 0.3s ease-in-out;

      &:hover {
        background: rgba(68, 151, 150, 0.2);
      }
    }

    .disabled-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .values {
    height: 42px;
    line-height: 42px;

    .value {
      width: 100%;
      height: 100%;
      color: $high;
      @extend .text-overflow;
    }

    .amount {
      font-size: 30px;
    }

    .address {
      font-size: 20px;
    }
  }
}
</style>
